import EContract, { EContractStatus } from '@core/classes/EContract';
import FIMenu from '@core/classes/FIMenu';
import { ISaturnResponse } from '@core/classes/Responses/SaturnResponse';
import request from '@core/services/request';

export const financeChannelsAPI = {
	submitDocuments: (dealId: any, packetSelectedDocuments: any, uploadedSelectedDocuments: any) => {
		return request.post(`/FinanceChannels/SubmitDocuments?dealId=${dealId}`, {
			uploadedSelectedDocuments,
			packetSelectedDocuments,
		});
	},
	sendCreditApplication: (fimenu: any, lender: any, additionalInfo: any) =>
		request.post(`/FinanceChannels/SendCreditApplication`, {
			fimenu,
			lender,
			additionalInfo,
		}),
	getCreditApplicationWithLastDecisionUpdate: (dealId: any, dealKind: any) =>
		request.get(`/FinanceChannels/GetCreditApplicationWithLastDecisionUpdate?dealId=${dealId}&kind=${dealKind}`),
	getCustomFields: (deal: any, lenderCode: any, tokenId: any) =>
		request.post(`/FinanceChannels/GetLenderCustomFields/${lenderCode}`, deal, {
			cancelToken: request.getCancellationToken(tokenId),
		}),
	getAvailableLenderCodesForSubmission: (providerStoreCodes: any) =>
		request.post(`/FinanceChannels/GetAvailableLenderCodesForSubmission`, {
			providerStoreCodes,
		}),
	getEContractStatus: (dealJacketId: string, dealerId: string, partnerId: string) =>
		request.get<ISaturnResponse<EContractStatus | null>>(
			`/FinanceChannels/GetEContractStatus?dealJacketId=${dealJacketId}&dealerId=${dealerId}&partnerId=${partnerId}`,
		),
	markApplicationMessagesAsRead: (applicationId: string) =>
		request.post<{ applicationId: string }, ISaturnResponse<void>>(`/FinanceChannels/MarkMessagesAsRead`, { applicationId }),
};

export const generateEContract = (deal: FIMenu) =>
	request.post<{ deal: FIMenu }, ISaturnResponse<EContractStatus | null>>(`/FinanceChannels/GenerateEContract`, { deal });
export const finalizeEContract = (dealId: string) => request.post(`/FinanceChannels/FinalizeEContract?dealId=${dealId}`);

export const submitDealJacketWithCustomersOnly = (reqObj: any) => request.post('/FinanceChannels/SubmitDealJacketWithCustomersOnly', reqObj);

export const sendDealJacket = (deal: FIMenu) => request.post(`/FinanceChannels/SendDealJacket`, { deal });

export const updateDealJacket = (fimenu: any) => request.post('/FinanceChannels/UpdateCreditApp', fimenu);

export const getDealJacketJSON = (id: any, transactionId?: string) => {
	let url = `/FinanceChannels/GetDealJacketJSON?id=${id}`;
	if (transactionId) {
		url += `&transactionId=${transactionId}`;
	}
	return request.get(url);
};

export const eContract = (deal: FIMenu) => request.post<{ deal: FIMenu }, ISaturnResponse<EContract | null>>(`/FinanceChannels/eContract`, { deal });

export const sendCreditApplication = (deal: FIMenu, lender: any, additionalInfo: any) =>
	request.post(`/FinanceChannels/SendCreditApplication`, {
		fimenu: deal,
		lender,
		additionalInfo,
	});

export const getCustomFields = (deal: any, lenderCode: any, tokenId: any) =>
	request.post(`/FinanceChannels/GetLenderCustomFields/${lenderCode}`, deal, {
		cancelToken: request.getCancellationToken(tokenId),
	});
